import { Button, Layout, Space, theme, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IoAddSharp } from "react-icons/io5";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import routes from "../../../engine/routes";
import { getPrincipals } from "../Slices/Principals.slice";
import CustomTable from "../../../shared/components/CustomTable";
import {
  columnsPrincipalsList,
  inputsPrincipalsSearchList,
} from "./PrincipalsListForms";
import { AlignCenterEnd } from "../../../shared/components/AlignCenterEnd/AlignCenterEnd";
import CustomForm from "../../../shared/components/CustomForm";
import { inputsInstitutionsList } from "../../Institutions/InstitutionsList/InstitutionsListForms";
import { getInstitutions } from "../../Institutions/Slices/Institutions.slice";
import { objectToUrlParams } from "../../../utils/helpersFunction";


const { Content, Sider, Header, Footer } = Layout;

export function Principalslist(props) {
  const { t } = useTranslation();
  const { principals, loading } = useSelector(state => state.principals);
  const dispatch = useDispatch();

  const {
    token: { colorBgLyout },
  } = theme.useToken();

  useEffect(() => {
    dispatch(getPrincipals());
  }, []);

  const [search, setSearch] = useState("");

  const dispatchActionInstitutions = search => {
    dispatch(getPrincipals(search));
  };

  useEffect(() => {
    const search = objectToUrlParams({});
    dispatchActionInstitutions(search);
  }, []);

  const onValuesChange = (changedValues, allValues) => {
    Object.keys(changedValues).map(changed => {
      switch (changed) {
        case "search":
          setSearch(changedValues[changed]);
          break;
      }
    });
  };

  const searchFilterData = () =>
    principals.filter(principal => {
      const {
        name = "",
        interventionLocation = "",
        tags = [],
        type = "",
        mainType = "",
        secondName = "",
        address = "",
      } = principal;
      const searchLowerCase = search.toLowerCase();

      let stringTags = "";

      if (tags !== null) {
        stringTags = tags?.map(e => e.label + "")?.join(" ");
      }

      const hasSearchMatch = [
        name,
        address,
        type,
        secondName === null ? "" : secondName,
        stringTags,
        mainType,
        interventionLocation,
      ]
        .filter(e => e !== null || e !== undefined)
        .some(field => field.toLowerCase().includes(searchLowerCase));

      return search.length === 0 || hasSearchMatch;
    });

  let copyPrincipals = searchFilterData();

  return (
    <Content>
      <Space
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography.Title level={2} className={""}>
          {t('PrincipalsList.principals')}
        </Typography.Title>
        <Link to={routes.principals().new.path}>
          <Button
            size={"large"}
            type={"primary"}
            style={{ justifySelf: "flex-start", display: "flex" }}
            icon={<IoAddSharp style={{ marginTop: "0px" }} size={25} />}
          >
            {t('PrincipalsList.addNewPrincipal')}
          </Button>
        </Link>
      </Space>

      <AlignCenterEnd>
        <CustomForm
          style={{
            flex: 1,
            maxWidth: 1200,
            paddingRight: 20,
          }}
          dataSource={inputsPrincipalsSearchList}
          labelCol={24}
          wrapperCol={24}
          onValuesChange={onValuesChange}
        />
      </AlignCenterEnd>

      <br />
      <CustomTable
        smTitle={item => {
          return (
            <div className={"alignHeaderPage"}>
              <h2 className={"noMargin"}>{item.name}</h2>
            </div>
          );
        }}
        loading={loading}
        onRowLink={record => routes.principals(record._id).detail.path}
        hasPagination={true}
        dataSource={copyPrincipals}
        columns={columnsPrincipalsList}
        rowKey="_id"
      />
    </Content>
  );
}